import { render, staticRenderFns } from "./AppDrawer.vue?vue&type=template&id=5e83f7ba&scoped=true"
import script from "./AppDrawer.vue?vue&type=script&lang=js"
export * from "./AppDrawer.vue?vue&type=script&lang=js"
import style0 from "./AppDrawer.vue?vue&type=style&index=0&id=5e83f7ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e83f7ba",
  null
  
)

export default component.exports